import React, { useEffect, useState } from "react";
import {
  View,
  Dimensions,
  ScrollView,
  FlatList,
  Image,
  Text,
  TouchableOpacity,
} from "react-native";
import CustomButton from "../../../common/CustomButton";
import CHeader from "../CommonComponants/Header";
import Loader from "../../../common/Loader";
import ModalAlert from "../../../common/ModalAlert";
import { getAllVehiclesList } from "../../../api/apiManager";
import { get, isEmpty } from "lodash";
import { createTIPolicy } from "../../../api/tripInsurance";
import moment from "moment";
import useStyles from "./VehicleSelectionForDebit_Styles";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

export default function VehicleSelectionForDebit(props) {
  console.log(props, "lllllllll");
  const styles = useStyles();
  const isSmallDevice = Dimensions.get("window").width < 767;
  const [vehicleList, setVehicleList] = useState([]);
  const [targetVrn, setTargetVrn] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    navigate: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    if (alertModal.navigateScreen == "home" || alertModal.message =="Your one policy already opted."){
      props.setScreen("home");
      setAlertModalVisible(false);
    } else {
      setAlertModalVisible(false);
    }
  };

  useEffect(() => {
    getVehicleList();
  }, []);

  const getVehicleList = () => {
    setLoading(true);
    getAllVehiclesList()
      .then((res) => {
        setLoading(false);
        if (res && !isEmpty(res)) {
          setLoading(false);
          setVehicleList(res.filter((item) => item?.status == "Activated"));
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const vehicleSelelctionForCredit = (params) => {
    setTargetVrn(params.toVrn);
  };

  const createPolicyIssueApi = () => {
    setLoading(true)
    let insuredObj = {
      namePrefix: props?.data?.insuredDetails?.prefix,
      firstName: props?.data?.insuredDetails?.firstName,
      middleName: props?.data?.insuredDetails?.middleName,
      lastName: props?.data?.insuredDetails?.lastName,
      gender:
        props?.data?.insuredDetails?.gender == "M" ||   props?.data?.insuredDetails?.gender == "Male"
          ? "Male"
          : props?.data?.insuredDetails?.gender == "F" ||  props?.data?.insuredDetails?.gender == "Female"
          ? "Female"
          : "Others",
      dob: moment(props?.data?.insuredDetails?.dob,"DD/MM/YYYY").format("DD-MM-YYYY"),
      mobileNo: props?.data?.insuredDetails?.mobileNo,
      emailId: props?.data?.insuredDetails?.emailId,
      addressLine1: props?.data?.insuredDetails?.address1,
      addressLine2: props?.data?.insuredDetails?.address2,
      city: props?.data?.insuredDetails?.city,
      state: props?.data?.insuredDetails?.state,
      pincode: props?.data?.insuredDetails?.zipCode,
    };
    let policyInfoObj = {
      policyPlanId: props?.data?.policyInfo?.planId,
      recursiveFlag: props?.data?.policyInfo?.recurring == true ? "Y" : "N",
      policyStartDate:moment(new Date()).format("DDMMYYYYHHmmss"),
    };
    let reqObj = {
      mobileNo: global?.mobileNo,
      tagId: targetVrn?.fastagId,
      triggeringMode: "Hamburger-Menu",
      policyInfo:policyInfoObj,
      insuredDetails: insuredObj,
      nomineeDetails: props?.data?.nomineeDetails,
    };
    createTIPolicy(reqObj)
      .then((res) => {
        if (res.statusCode == 200 || res.statusCode == 1092) {
          setAlertModal({
            title: "Success",
            status: "success",
            message: res.message,
            navigateScreen: "home",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          setLoading(false)
        } else {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          setLoading(false)
        }
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
        setLoading(false)
      });
  };

  return (

    <View style={styles.mainContainer}>
      <CHeader
        title="Select Tag to debit from"
        onPress={() => {
          props.setScreen("Insurance");
        }}
        navigation=""
        showDesc={false}
      />
      <View
        style={{
          width: 200,
          height: 40,
          alignSelf: "flex-end",
          marginTop: -90,
          marginRight: 20,
        }}
      >
        <CustomButton
          text="Proceed to buy"
          disable={targetVrn == "" ? true : false}
          onPress={targetVrn == "" ? null :() => createPolicyIssueApi()}
        />
      </View>
      <View style={styles.custInfoWrapper}>
        <View style={styles.flatListView}>
          <ScrollView
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            horizontal
            style={{
              marginBottom: -30,
              marginTop: 20,
            }}
          >
            <FlatList
              extraData
              style={styles.flatListView}
              showsVerticalScrollIndicator={false}
              data={isEmpty(vehicleList) ? [] : vehicleList}
              key={Math.random().toString(36).substr(2, 5)}
              renderItem={({ item }) => {
                return (
                  <View style={styles.imgContainer}>
                    <View style={styles.firstContainer}>
                      <View style={styles.subView}>
                        <View style={{ marginVertical: 4 }}>
                          <Image
                            source={require("../../../assets/images/car.png")}
                            style={styles.bitMap}
                          />
                        </View>

                        <View style={styles.hondaTextContainer}>
                          <Text style={styles.textStyle2}>{item?.vrn}</Text>
                          <Text style={styles.honda}>{item?.vehicleModel}</Text>
                        </View>

                        <View style={styles.numberContainer}>
                          <Text style={styles.number}>
                            {item?.fastagBalance.toString().includes(".")
                              ? item?.fastagBalance.toFixed(2)
                              : item?.fastagBalance + ".00"}
                          </Text>
                          <TouchableOpacity
                            onPress={() => {
                              vehicleSelelctionForCredit({ toVrn: item });
                            }}
                            style={styles.radiobuttonOutSideStyle}
                          >
                            {targetVrn?.vrn == item.vrn ? (
                              <View style={styles.radioButtonInsideStyle} />
                            ) : null}
                          </TouchableOpacity>
                        </View>
                      </View>
                    </View>
                  </View>
                );
              }}
              numColumns={isSmallDevice ? null : isTabView ? 2 : 3}
            />
          </ScrollView>
        </View>
      </View>
      {alertModalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={alertModal.actionButton}
            onCloseModal={onCloseModal}
          />
        </View>
      )}

      {loading && <Loader />}
    </View>
  );
}
